import React, { Suspense, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  FormControl,
  InputGroup,
  Form,
  Table,
  Card,
} from "react-bootstrap";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";
import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx"; // Library for Excel file reading
import { saveAs } from "file-saver";
import TableComponent from "../../../../components/tableComponent/TableComponent";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Modals from "../../../../components/common/Modal";
import PrintInvoice from "../../../../components/common/Print/print";
// import { format } from "date-fns"; // Import the format function from date-fns

import {
  addInvoiceDetailsRequest,
  fetchCategoryRequest,
  fetchGradeRequest,
  fetchMarkRequest,
  fetchSaleProgramListRequest,
  fetchWarehouseUserRequest,
  getSaleNoRequest,
  teaTypeAction,
} from "../../../../store/actions/index";
import { useSelector } from "react-redux";

import axios from "axios";
import axiosMain from "../../../../http/axios/axios_main";
import FileUpload from "../../../../components/common/uploadFile/FileUpload";
import {
  checkAllcoulm,
  readFileAndCheckHeaders,
} from "../../../../components/common/uploadFile/utils";
import CustomToast from "../../../../components/Toast";
import { useAuctionDetail } from "../../../../components/common/AunctioneerDeteailProvider";
import ConfirmationModal from "../../../../components/common/DeleteConfirmationModal";
import { CircularProgress, Tooltip } from "@mui/material";
import ExportData from "../../../../components/common/exportData/ExportData";
import PrintableTable from "../../../../components/common/PrintableTable";
import { useLoader } from "../../../../components/common/Loder/Loder";
import newformatDateToDdMmYy from "../../../../components/common/dateAndTime/newconvertToDate";
// const TableComponent = React.lazy(() =>
//   import("../../../../components/tableComponent/TableComponent")
// );
const currentDate = new Date();
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ALLOWED_EXTENSIONS = [".xls", ".xlsx"];

const validationSchema = Yup.object().shape({
  markId: Yup.number()
    .min(1, "Please select Mark")
    .required("Mark is required"),
  status: Yup.number()
    .min(1, "Please select Status")
    .required("Status is required"),
});
const initialValues = {
  markId: "0",
  status: "0",
};
const UploadSellerChargesForm = ({
  isDisabled,
  // invoiceResponseData,
  // viewData,
  // srNo,
  expandedTab,
  setExpandedTab,
  invoiceStatusLable,
  isEdit,
  modalRight,
  formikhandlesubmit,
  tableData,
  setTableData,
}) => {
  const {
    auctionCenterId,
    userId,
    auction,
    roleCode,
    auctionTypeMasterCode,
    userCode,
  } = useAuctionDetail();
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();
  const [auctionType, setAuctionType] = useState(auction);
  const [auctionTypeCode, setAuctionTypeCode] = useState(auctionTypeMasterCode);
  const baseUrlEngn =
    auction === "ENGLISH" ? "EnglishAuctionInvoiceDetails" : "InvoiceDetails";
  const [baseUrlEng, setbaseUrlEng] = useState(baseUrlEngn);
  // const [formInitialData, setFormInitialData] = useState(initialValues);
  const [saleprogrmId, setsaleprogrmId] = useState(null);
  const [catalogClosingDate, setCatalogClosingDate] = useState(null);
  const [warehouseUserRegIdOnEdit, setWarehouseUserRegIdOnEdit] = useState([]);
  const [teaTypeList, setTeaTeatypeList] = useState([]);
  const [markDataList, setMarkDataList] = useState([]);
  const [warehouseUserList, setWarehouseUserList] = useState([]);
  const [gradesList, setGradesList] = useState([]);
  const [saleNo, setSaleNo] = useState([]);
  const [subTeaTypeNo, setSubTeaTypeNo] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [FileErrors, setErrors] = useState({});
  const [invoiceData, setInvoiceData] = useState([]);
  const [catagory, setCategory] = useState([]);
  const [sampleList, setSampleList] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [validationData, setValidationData] = useState([]);

  const [auctioneer, setAuctioneer] = useState([]);
  const [catalogclosedate, setCatalogclosingDates] = useState("");
  const [rows, setRows] = useState([]);

  const [propertyNameList, setPropertyNameList] = useState([
    {
      name: "MarkCode",
      title: "Mark",
    },
    { name: "PILS", title: "PILS" },
    {
      name: "DamageClaims",
      title: "Damage Claims",
    },
    { name: "SellerChestageAllowance", title: "Seller Chestage Allowance" },
    {
      name: "WithdrawnCharges",
      title: "Withdrawn Charges(Excluding Taxes)",
    },
    // { name: "auctioneerId", title: "Auctioneer ID" },
    {
      name: "SPTFRecovery",
      title: "SPTF",
    },
    {
      name: "FreightCharges",
      title: "Freight Charges",
    },
    { name: "Remarks", title: "Remarks" },
    { name: "ReferenceNo", title: "Reference No." },
  ]);
  const [uploadData, setUploadData] = useState([]);
  const [originDataList, setOriginDataList] = useState([]);
  const [manufacturerIdd, setmanufacturerIdd] = useState(0);
  const [openModalConformation, setOpenModalConformation] = useState(false);
  const [origindata, setorigin] = useState(false);
  const [
    openModalConformationInvalidData,
    setOpenModalConformationInvalidData,
  ] = useState(false);
  const [
    openModalConformationInvalidDataTitle,
    setOpenModalConformationInvalidDataTitle,
  ] = useState({});
  const [openModalConformationTitle, setOpenModalConformationTitle] =
    useState("");
  const [openConformaionModal, setOpenConformaionModal] = useState(false);

  const [packegetype, setpackegetype] = useState([]);
  const [packegesize, setpackegesize] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openPrintModel, setopenPrintModel] = useState(false);
  const [printrow, setprintrow] = useState([]);
  const manuallypropertyNames = [
    {
      name: "markId",
      title: "Mark",
      getCellValue: ({ ...row }) => (
        <span>
          {markDataList?.map((ele) =>
            ele.markId == row?.markId ? ele.markName : ""
          )}
        </span>
      ),
    },
    { name: "season", title: "Season" },
    {
      name: "teaType",
      title: "Tea Type",
      getCellValue: ({ ...row }) => (
        <span>
          {teaTypeList?.map((ele) =>
            ele.teaTypeId == row?.teatypeid ? ele.teaTypeName : ""
          )}
        </span>
      ),
    },
    { name: "saleNo", title: "Sale No" },
    {
      name: "wareHouseUserReg",
      title: "Warehouse User Registration",
      getCellValue: ({ ...row }) => (
        <span>
          {warehouseUserList?.map((ele) =>
            ele.wareHouseUserRegId === row?.wareHouseUserRegId
              ? ele.wareHouseName
              : ""
          )}
        </span>
      ),
    },
    // { name: "auctioneerId", title: "Auctioneer ID" },
    {
      name: "categoryId",
      title: "Category",
      getCellValue: ({ ...row }) => (
        <span>
          {category?.map((ele) =>
            ele.categoryId === row?.categoryId ? ele.categoryName : ""
          )}
        </span>
      ),
    },
    { name: "manufactureFromDate", title: "Manufacture From Date" },
    { name: "manufactureToDate", title: "Manufacture To Date" },
    { name: "dateOfDispatch", title: "Date of Dispatch" },
    { name: "invoiceDate", title: "Invoice Date" },
    { name: "carrier", title: "Carrier" },
    { name: "lorryReceiptNo", title: "Lorry Receipt Number" },
    { name: "lorryNo", title: "Lorry Number" },
    { name: "invoiceNo", title: "Invoice Number" },
    { name: "arrivalDate", title: "Arrival Date" },
    { name: "awrDate", title: "AWR Date" },
    { name: "awrReferenceNo", title: "AWR Reference Number" },
    {
      name: "subTeaTypeId",
      title: "Sub Tea Type",
      getCellValue: ({ ...row }) => (
        <span>
          {subTeaType?.map((ele) =>
            ele.subTeaTypeId === row?.subTeaTypeId ? ele.subTeaTypeName : ""
          )}
        </span>
      ),
    },
    {
      name: "gradeId",
      title: "Grade",
      getCellValue: ({ ...row }) => (
        <span>
          {gradesList?.map((ele) =>
            ele.gradeId === row?.gradeId ? ele.gradeName : ""
          )}
        </span>
      ),
    },
    {
      name: "packageType",
      title: "Package Type",
      // getCellValue: ({ ...row }) => <span>Paper sacks</span>,
    },
    {
      name: "packageSize",
      title: "Package Size",
      // getCellValue: ({ ...row }) => <span> 27x21x11</span>,
    },
    { name: "packageNo", title: "Package Number" },
    { name: "totalPackages", title: "Total Packages" },
    { name: "grossKgs", title: "Gross Kgs" },
    { name: "tareKgs", title: "Tare Kgs" },
    { name: "netKgs", title: "Net Kgs" },
    { name: "totalNetKgs", title: "Total Net Kgs" },
    { name: "gpNo", title: "GP Number" },
    { name: "gpDate", title: "GP Date" },
    { name: "shortExcessWeight", title: "Short Excess Weight" },
    { name: "locationInsideWarehouse", title: "Location Inside Warehouse" },
    // {
    //   name: "isActive",
    //   title: "Is Active",
    //   getCellValue: ({ ...row }) => (
    //     <span>{row.isActive == true ? "true" : "false"}</span>
    //   ),
    // },
    // { name: "createdBy", title: "Created By" },
    { name: "invoiceQty", title: "Invoice Qty" },
    // {
    //   name: "action",
    //   title: "Action",
    //   getCellValue: ({ ...row }) => <ActionArea data={row} />,
    // },
  ];
  function findDuplicateInvoiceNumbers(arrayOfObjects) {
    arrayOfObjects.filter(
      (ele, index) => ele.MarkCode === arrayOfObjects[index + 1]?.MarkCode
    );
    //debugger;;

    return arrayOfObjects;
  }

  // const handleDownload = () => {
  //   let documentName = "InvoiceSample.xlsx";

  //   // Get the current date and time
  //   let currentDate = new Date();
  //   let options = { timeZone: "Asia/Kolkata" }; // Set the time zone to Indian Standard Time
  //   let formattedDate = currentDate
  //     .toLocaleString("en-US", options)
  //     .replace(/[\/.,]/g, "-"); // Format the date as a string and replace certain characters

  //   // Append the formatted date and time to the document name
  //   documentName = documentName.replace(/\.xlsx$/, `_${formattedDate}.xlsx`);
  //   // "http://192.168.100.164:5080/preauction/Common/GenerateExcel"
  //   axiosMain
  //     .post(
  //       // "/preauction/InvoiceDetails/DownloadInvoiceSampleExcel?role=" +roleCode,
  //       "/preauction/Common/GenerateExcel",
  //       {
  //         season: formik.values.season.toString(),
  //         saleNo: parseInt(formik.values.saleNo),
  //         auctionCenterId: auctionCenterId,
  //         auctioneerId: userId,
  //         factoryId: parseInt(manufacturerIdd),
  //         status: 0,
  //       }
  //       // rows?.map((ele) => {
  //       //   return { LotNo: ele.LotNo };
  //       // })
  //     )
  //     .then((res) => {
  //       let documentBytes = res?.data;

  //       // Decode base64 encoded documentBytes
  //       const decodedBytes = atob(documentBytes);

  //       // Create a Blob from the decoded bytes
  //       const blob = new Blob([
  //         new Uint8Array([...decodedBytes].map((char) => char.charCodeAt(0))),
  //       ]);

  //       // Create an object URL from the Blob
  //       const blobUrl = URL.createObjectURL(blob);

  //       // Create a hidden anchor element
  //       const anchor = document.createElement("a");
  //       anchor.style.display = "none";
  //       anchor.href = blobUrl;
  //       anchor.download = documentName;

  //       // Append anchor to the body
  //       document.body.appendChild(anchor);

  //       // Programmatically click the anchor element
  //       anchor.click();

  //       // Clean up: remove the anchor and revoke the object URL
  //       document.body.removeChild(anchor);
  //       URL.revokeObjectURL(blobUrl);
  //     })
  //     .catch((err) => console.log(err));
  // };

  const submitInvoice = () => {
    //debugger;;
    console.log(fileInputRef.current.value, "abc");
    if (
      fileInputRef.current.value === "" ||
      fileInputRef.current.value === undefined ||
      fileInputRef.current.value === null
    ) {
      CustomToast.error("Please Select Excel file");
      return false;
    }
    if (uploadData.length > 0) {
      // if (allTrue) {
      //SDP Validation

      const checkmark = uploadData
        ?.map((ele) => ele?.MarkCode !== "" && ele?.MarkCode !== undefined)
        .map((ele, index) => ele === false && index + 1)
        .filter((ele) => ele !== false);

      const checkreferenceno = uploadData
        ?.map((ele) =>
          ele?.ReferenceNo !== "" && ele?.ReferenceNo !== undefined
            ? ""
            : ele.MarkCode
        )
        .filter((ele) => ele !== "");
      // .map((ele, index) => ele === false && ele.LotNo)

      const specialCharacterRegex = /[^a-zA-Z0-9]/;

      const checkreferencenospecialch = uploadData
        ?.map((ele) => {
          const refNo = ele?.ReferenceNo;

          const isInvalid =
            !refNo || refNo === "" || specialCharacterRegex.test(refNo);
          return isInvalid ? ele.MarkCode : "";
        })
        .filter((ele) => ele !== "");
      // .map((ele, index) => ele && index + 1)

      const checkarrayamount = uploadData
        .map((ele, index) => {
          const filledFields = [
            ele.PILS,
            ele.DamageClaims,
            ele.SellerChestageAllowance,
            ele.FreightCharges,
            ele.WithdrawnCharges,
          ].filter((value) => value !== undefined && isNaN(parseFloat(value)));
          if (filledFields.length >= 2) {
            return index + 1;
          } else return 1;
        })
        .filter((ele) => ele !== 1);

      const checkarraynoamount = uploadData
        .map((ele, index) => {
          const filledFields = [
            ele.PILS,
            ele.DamageClaims,
            ele.SellerChestageAllowance,
            ele.FreightCharges,
            ele.WithdrawnCharges,
          ].filter((value) => (value === undefined ? 0 : value) > 0);
          if (filledFields.length === 0) {
            return index + 1;
          } else return 0;
        })
        .filter((ele) => ele !== 0);
      let dataList = uploadData?.map((ele) => {
        const filledFields = [
          ele.PILS,
          ele.DamageClaims,
          ele.SellerChestageAllowance,
          ele.FreightCharges,
          ele.WithdrawnCharges,
        ];
        return filledFields;
      });
      // .reduce((cur, aqq) => cur.concat(aqq), []);
      // .some((ele) => ele === 0);
      let checkAllZero = dataList
        .map(
          (ele, index) =>
            ele.filter((item) => item !== 0 && item !== undefined).length >= 2
        )
        .map((ele, index) => (ele ? uploadData[index]?.MarkCode+ "-" + uploadData[index]?.ReferenceNo : ""))
        .filter((ele) => ele !== "");

      const checkpilsnegetivewithlength = uploadData
        ?.map((ele) =>
          ele?.PILS?.toString() !== undefined && ele?.PILS?.toString() !== ""
            ? typeof ele?.PILS === "number" &&
              ele?.PILS?.toString().replace(".", "").length <= 20
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const allpilsvalid = uploadData
        ?.map((ele) =>
          // ele?.PILS?.toString() !== undefined &&
          ele?.PILS?.toString() !== "" && parseFloat(ele.PILS) >= 0
            ? typeof ele?.PILS === "number"
              ? parseFloat(ele.PILS) > 0
                ? ele?.PILS?.toString()?.split(".")[1] === undefined
                  ? true
                  : ele?.PILS?.toString()?.split(".")[1]?.length <= 2
                    ? true
                    : ele.MarkCode
                : true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      // const pilsdecimallen = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.PILS?.toString() !== "" &&
      //       (ele?.PILS?.toString()?.split(".")[1]?.length <= 2 ||
      //         ele.PILS?.toString()?.split(".")[1] === undefined)
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);

      const checkpilsnegetive = uploadData
        ?.map((ele) =>
          ele?.PILS?.toString() !== undefined && ele?.PILS?.toString() !== ""
            ? typeof ele?.PILS === "number"
            : true
        )
        .map((ele, index) => ele === false && index + 1 + 1)
        .filter((ele) => ele !== false);

      //DAMAGE CLAIMS
      // const checkdamageClaims = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.DamageClaims !== "" && ele?.DamageClaims !== undefined
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);

      const checkdamageClaimsnegetivewithlength = uploadData
        ?.map((ele) =>
          ele?.DamageClaims?.toString() !== "" &&
            ele?.DamageClaims?.toString() !== undefined
            ? typeof ele?.DamageClaims === "number" &&
              ele?.DamageClaims?.toString().length <= 20 &&
              ele.DamageClaims >= 0
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const alldamageClaimsvalid = uploadData
        ?.map((ele) =>
          ele?.DamageClaims?.toString() !== undefined &&
            ele?.DamageClaims?.toString() !== ""
            ? typeof ele?.DamageClaims === "number" &&
              (ele?.DamageClaims?.toString()?.split(".")[1]?.length <= 2 ||
                ele.DamageClaims?.toString()?.split(".")[1] === undefined) &&
              ele.DamageClaims >= 0
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const checkdamageClaimsnegetive = uploadData
        ?.map((ele) =>
          ele?.DamageClaims?.toString() !== "" &&
            ele?.DamageClaims?.toString() !== undefined
            ? typeof ele?.DamageClaims === "number"
            : true
        )
        .map((ele, index) => ele === false && index + 1 + 1)
        .filter((ele) => ele !== false);
      //END DAMAGE CLAIMS
      //Seller charges
      // const checksellerChestageAllowance = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.SellerChestageAllowance !== "" && ele?.SellerChestageAllowance !== undefined
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);

      const checksellerChestageAllowancenegetivewithlength = uploadData
        ?.map((ele) =>
          ele?.SellerChestageAllowance?.toString() !== "" &&
            ele?.SellerChestageAllowance?.toString() !== undefined
            ? typeof ele?.SellerChestageAllowance === "number" &&
              ele?.SellerChestageAllowance?.toString().length <= 20
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const allSellerChestageAllowance = uploadData
        ?.map((ele) =>
          ele?.SellerChestageAllowance?.toString() !== undefined &&
            ele?.SellerChestageAllowance?.toString() !== ""
            ? typeof ele?.SellerChestageAllowance === "number" &&
              (ele?.SellerChestageAllowance?.toString()?.split(".")[1]
                ?.length <= 2 ||
                ele.SellerChestageAllowance?.toString()?.split(".")[1] ===
                undefined) &&
              ele.SellerChestageAllowance >= 0
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const checksellerChestageAllowancenegetive = uploadData
        ?.map((ele) =>
          ele?.SellerChestageAllowance?.toString() !== "" &&
            ele?.SellerChestageAllowance?.toString() !== undefined
            ? typeof ele?.SellerChestageAllowance === "number"
            : true
        )
        .map((ele, index) => ele === false && index + 1 + 1)
        .filter((ele) => ele !== false);
      //END Seller CHARGES
      //Withdran charges
      // const checkwithdrawnCharges = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.WithdrawnCharges !== "" && ele?.WithdrawnCharges !== undefined
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);

      const checkwithdrawnChargesnegetivewithlength = uploadData
        ?.map((ele) =>
          ele?.WithdrawnCharges?.toString() !== "" &&
            ele?.WithdrawnCharges?.toString() !== undefined
            ? typeof ele?.WithdrawnCharges === "number" &&
              ele?.WithdrawnCharges?.toString().length <= 20
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      // const checkwithdrawnChargesnegetive = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.WithdrawnCharges?.toString() !== "" && ele?.WithdrawnCharges?.toString() !== undefined ?
      //         (typeof ele?.WithdrawnCharges) === "number" : true
      //   )
      //   .map((ele, index) => ele === false && index + 1 + 1)
      //   .filter((ele) => ele !== false);

      const allWithdrawnCharges = uploadData
        ?.map((ele) =>
          ele?.WithdrawnCharges?.toString() !== undefined &&
            ele?.WithdrawnCharges?.toString() !== ""
            ? typeof ele?.WithdrawnCharges === "number" &&
              (ele?.WithdrawnCharges?.toString()?.split(".")[1]?.length <= 2 ||
                ele.WithdrawnCharges?.toString()?.split(".")[1] ===
                undefined) &&
              ele.WithdrawnCharges >= 0
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);
      //END Withdran CHARGES

      //sptf charges
      // const checksptf = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.SPTFRecovery !== "" && ele?.SPTFRecovery !== undefined
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);

      const checksptfnegetivewithlength = uploadData
        ?.map((ele) =>
          ele?.SPTFRecovery?.toString() !== "" &&
            ele?.SPTFRecovery?.toString() !== undefined
            ? typeof ele?.SPTFRecovery === "number" &&
              ele?.SPTFRecovery?.toString().length <= 20
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const allsptf = uploadData
        ?.map((ele) =>
          ele?.SPTFRecovery?.toString() !== undefined &&
            ele?.SPTFRecovery?.toString() !== ""
            ? typeof ele?.SPTFRecovery === "number" &&
              (ele?.SPTFRecovery?.toString()?.split(".")[1]?.length <= 2 ||
                ele.SPTFRecovery?.toString()?.split(".")[1] === undefined) &&
              ele.SPTFRecovery >= 0
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const checksptfnegetive = uploadData
        ?.map((ele) =>
          ele?.SPTFRecovery?.toString() !== "" &&
            ele?.SPTFRecovery?.toString() !== undefined
            ? typeof ele?.SPTFRecovery === "number"
            : true
        )
        .map((ele, index) => ele === false && index + 1 + 1)
        .filter((ele) => ele !== false);
      //END sptf CHARGES

      //freightCharges charges
      // const checkfreightCharges = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.FreightCharges !== "" && ele?.FreightCharges !== undefined
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);

      const checkfreightChargesnegetivewithlength = uploadData
        ?.map((ele) =>
          ele?.FreightCharges?.toString() !== "" &&
            ele?.FreightCharges?.toString() !== undefined
            ? typeof ele?.FreightCharges === "number" &&
              ele?.FreightCharges?.toString().length <= 20
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const allFreightCharges = uploadData
        ?.map((ele) =>
          ele?.FreightCharges?.toString() !== undefined &&
            ele?.FreightCharges?.toString() !== ""
            ? typeof ele?.FreightCharges === "number" &&
              (ele?.FreightCharges?.toString()?.split(".")[1]?.length <= 2 ||
                ele.FreightCharges?.toString()?.split(".")[1] === undefined) &&
              ele.FreightCharges >= 0
              ? true
              : ele.MarkCode
            : ele.MarkCode
        )
        .filter((ele) => ele !== true);

      const checkfreightChargesnegetive = uploadData
        ?.map((ele) =>
          ele?.FreightCharges?.toString() !== "" &&
            ele?.FreightCharges?.toString() !== undefined
            ? typeof ele?.FreightCharges === "number"
            : ele.MarkCode
        )
        .map((ele, index) => ele === false && index + 1 + 1)
        .filter((ele) => ele !== false);
      //END freightCharges CHARGES

      // const checkdecimalpils = uploadData
      //   ?.map(
      //     (ele) =>
      //       ele?.PILS?.toString() !== "" &&
      //       (ele?.PILS?.toString()?.split(".")[1]?.length <= 2 ||
      //         ele.pils?.toString()?.split(".")[1] === undefined)
      //   )
      //   .map((ele, index) => ele === false && index + 1)
      //   .filter((ele) => ele !== false);

      //End
      //debugger;;

      let checkAllZeroOfMarks = dataList
        .map(
          (ele, index) =>
            ele.filter((item) => item === 0 || item === undefined).length ===
            ele.length
        )
        .map((ele, index) => (ele ? uploadData[index]?.MarkCode + "-" + uploadData[index]?.ReferenceNo : ""))
        .filter((ele) => ele !== "");
      debugger;

      if (checkAllZeroOfMarks.length > 0) {
        // if (dataList.map((ele, index) => ele.filter((item) => item < 0)))
        CustomToast.error(
          "Please enter at least one seller charge in Mark-ReferenceNo: " +
          checkAllZeroOfMarks?.join(", ")
        );
        return false;
      }
      if (checkAllZero?.length > 0) {
        CustomToast.error(
          "Only one type of charge is allowed in a Mark. Please check Mark-ReferenceNo:: " +
          checkAllZero?.join(", ")
        );
        return false;
      }
      // const duplicates = findDuplicateInvoiceNumbers(uploadData);

      // Step 1: Group the records by ReferenceNo
      const groupedRecords = uploadData?.reduce((acc, record) => {
        const { ReferenceNo, MarkCode } = record;

        // Initialize array for ReferenceNo if it doesn't exist
        if (!acc[ReferenceNo]) {
          acc[ReferenceNo] = [];
        }

        // Add the MarkCode to the corresponding ReferenceNo
        acc[ReferenceNo].push(MarkCode);

        return acc;
      }, {});

      // Step 2: Find ReferenceNo entries that have the same MarkCode multiple times
      const duplicates = Object.entries(groupedRecords)
        .filter(([referenceNo, markCodes]) => {
          // Check if there are duplicate MarkCodes in the array
          return markCodes.some(
            (markCode, index) => markCodes.indexOf(markCode) !== index
          );
        })
        .map(([referenceNo, markCodes]) => markCodes[0]);
      // const duplicates = findDuplicateInvoiceNumbers(uploadData);

      if (checkmark.length > 0) {
        CustomToast.error(
          "Please select valid Mark Code in row no. " + checkmark
        );
        return false;
      } else if (allpilsvalid.length > 0) {
        //debugger;;
        CustomToast.error(
          "Numeric values (0-9) with a maximum of two decimal places are allowed in PILS for Mark: " +
          allpilsvalid?.join(",")
        );
      } else if (checkpilsnegetivewithlength > 0) {
        CustomToast.error(
          "Maximum 20 numeric values are only allowed in PILS for Mark: " +
          checkpilsnegetivewithlength?.join(",") +
          ""
        );
      } else if (alldamageClaimsvalid.length > 0) {
        CustomToast.error(
          "Numeric values (0-9) with a maximum of two decimal places are allowed in Damage Claims for Mark: " +
          alldamageClaimsvalid?.join(",") +
          ""
        );
      } else if (checkdamageClaimsnegetivewithlength.length > 0) {
        CustomToast.error(
          "Maximum 20 numeric values are only allowed in Damage Claims for Mark: " +
          checkdamageClaimsnegetivewithlength?.join(",") +
          ""
        );
      } else if (allSellerChestageAllowance.length > 0) {
        CustomToast.error(
          "Numeric values (0-9) with a maximum of two decimal places are allowed in Chestage Allowance for Mark: " +
          allSellerChestageAllowance?.join(",") +
          ""
        );
      } else if (checksellerChestageAllowancenegetivewithlength.length > 0) {
        CustomToast.error(
          "Maximum 20 numeric values are only allowed in Chestage Allowance for Mark: " +
          checksellerChestageAllowancenegetivewithlength?.join(",") +
          ""
        );
      } else if (allWithdrawnCharges.length > 0) {
        CustomToast.error(
          "Numeric values (0-9) with a maximum of two decimal places are allowed in Withdrawn Charges for Mark: " +
          allWithdrawnCharges?.join(",") +
          ""
        );
      } else if (checkwithdrawnChargesnegetivewithlength.length > 0) {
        CustomToast.error(
          "Maximum 20 numeric values are only allowed in Withdrawn Charges for Mark: " +
          checkwithdrawnChargesnegetivewithlength?.join(",") +
          ""
        );
      } else if (allsptf.length > 0) {
        CustomToast.error(
          "Numeric values (0-9) with a maximum of two decimal places are allowed in SPTF for Mark: " +
          allsptf?.join(",") +
          ""
        );
      } else if (checksptfnegetivewithlength.length > 0) {
        CustomToast.error(
          "Maximum 20 numeric values are only allowed in SPTF for Mark: " +
          checksptfnegetivewithlength?.join(",") +
          ""
        );
      } else if (allFreightCharges.length > 0) {
        CustomToast.error(
          "Numeric values (0-9) with a maximum of two decimal places are allowed in Freight Charges for Mark: " +
          allFreightCharges?.join(",") +
          ""
        );
      } else if (checkfreightChargesnegetivewithlength.length > 0) {
        CustomToast.error(
          "Maximum 20 numeric values are only allowed in Freight Charges for Mark: " +
          checkfreightChargesnegetivewithlength?.join(",") +
          ""
        );
      }
      // else if (checkarrayamount.length > 0) {
      //   CustomToast.error(
      //     "You can Enter Only one seller charge in Row No." +
      //       checkarrayamount?.join(",")
      //   );
      // } else if (checkarraynoamount.length > 0) {
      //   CustomToast.error(
      //     "Please enter at least one seller charge in Row No." +
      //       checkarraynoamount?.join(",")
      //   );
      // }
      else if (checkreferenceno.length > 0) {
        CustomToast.error(
          "Please enter Reference No. in Mark :" + checkreferenceno?.join(",")
        );
      } else if (duplicates.length > 0) {
        CustomToast.error(
          "Reference No(s). are already exist for Mark :" +
          duplicates.join(", ")
        );
        return false;
      } else if (checkreferencenospecialch.length > 0) {
        CustomToast.error(
          "Only alphanumeric characters (0-9, A-Z, a-z) are allowed in Mark :" +
          " " +
          checkreferencenospecialch.join(", ")
        );
        return false;
      } else if (
        uploadData.filter((ele) => ele.ReferenceNo.length > 20)?.length > 0
      ) {
        CustomToast.error(
          "Maximum length of Reference No should be 20 in Mark :" +
          " " +
          uploadData
            .filter((ele) => ele.ReferenceNo.length > 20)
            ?.map((ele) => ele.MarkCode)
            .join(", ")
        );
        return false;
      } else if (
        uploadData.filter(
          (ele) =>
            ele.Remarks?.toString()
              ?.split(" ")
              ?.filter((items) => items !== " ")
              ?.join("")?.length > 1000
        )?.length > 0
      ) {
        CustomToast.error(
          "Maximum 1000 allowed in Remarks for Mark:" +
          uploadData
            .filter(
              (ele) =>
                ele.Remarks?.toString()
                  ?.split(" ")
                  ?.filter((items) => items !== " ")
                  ?.join("")?.length > 1000
            )
            ?.map((ele) => ele.MarkCode)
            ?.join(", ")
        );
      }
      //END freightCharges CHARGES

      //END
      else {
        // openLoader();
        // dispatch(addInvoiceDetailsRequest(invoiceData));
        openLoader();
        axiosMain
          .post(
            "/preauction/SellerCharges/UploadSellerCharges?flag=upload&validateAction=validate",
            uploadData.map((ele) => ({
              ...ele,
              DamageClaims:
                ele.DamageClaims === undefined ? 0 : ele.DamageClaims,
              SellerChestageAllowance:
                ele.SellerChestageAllowance === undefined
                  ? 0
                  : ele.SellerChestageAllowance,
              WithdrawnCharges:
                ele.WithdrawnCharges === undefined ? 0 : ele.WithdrawnCharges,
              SPTFRecovery:
                ele.SPTFRecovery === undefined ? 0 : ele.SPTFRecovery,
              FreightCharges:
                ele.FreightCharges === undefined ? 0 : ele.FreightCharges,
              PILS: ele.PILS === undefined ? 0 : ele.PILS,
              ReferenceNo: ele.ReferenceNo?.toString(),
              MarkId: 0,
              auctionCenterId
            }))
          )
          .then((response) => {
            if (response.data.statusCode === 202) {
              setOpenConformaionModal(true);
              CustomToast.success(response.data.message);
            }
            // else if (response.data.statusCode === 422) {
            //   // CustomToast.warning(response.data.message);
            //   setOpenConformaionModal(false);
            //   setOpenModalConformation(true);
            //   setOpenModalConformationTitle(response.data.message);
            // } else if (response.data.statusCode === 423) {
            //   // CustomToast.warning(response.data.message);
            //   setOpenConformaionModal(false);
            //   setOpenModalConformationInvalidData(true);
            //   setOpenModalConformationInvalidDataTitle({
            //     title: response.data.message,
            //     responseData: response.data.responseData,
            //   });
            //   console.log(response.data, "response.data.message");
            // }
            else {
              setOpenConformaionModal(false);
              CustomToast.error(response.data.message);
            }
            // Handle the response data or success
            closeLoader();
          })
          .catch((error) => {
            closeLoader();
            CustomToast.error("API call failed:", error);
            // Handle errors here
          });
      }
      // console.log(invoiceData, "datadatadata");
      // }
      //  else {
      //   console.log("Not all elements are true.");
      // }
    } else CustomToast.error("Validation is unsuccessful");
  };
  useEffect(() => {
    setTableData([]);
    setInvoiceData([]);
    setUploadData([]);
    fileInputRef.current.value = "";
  }, [expandedTab]);

  // const handleSubmit = (values) => {
  //   openLoader();
  //   // Handle form submission here, values object will contain the form data
  //   const { markId, status } = values;
  //   const data = {
  //     markId: parseInt(markId),
  //     status: parseInt(status),
  //     // role:roleCode
  //   };
  //   // dispatch(fetchInvoiceDetailsRequest(data));
  //   axiosMain
  //     .post(
  //       `/preauction/${baseUrlEng}/GetSellerCharges?role=` + roleCode,
  //       data
  //     )
  //     .then((res) => {
  //       setRows(res.data.responseData);
  //       closeLoader();
  //     });
  //   // console.log(values);
  // };
  // const formik = useFormik({
  //   initialValues,
  //   validationSchema,
  //   onSubmit: handleSubmit,
  // });
  // console.log(parseInt(saleprogrmId), "saleee");

  // useEffect({wareHouseUserRegDetail},[formik.values.warehouse])

  // const [formData, setFormData] = useState();

  const teaType = useSelector(
    (state) => state.teaType.teaTypeList.responseData
  );
  const subTeaType = useSelector((state) => state.teaType.data.responseData);

  const warehouseUsersList = useSelector(
    (state) => state.warehouseUser.data.responseData
  );
  const grades = useSelector((state) => state.grade.data.responseData);

  const saleNumber = useSelector(
    (state) => state?.auction?.saleNumber?.responseData
  );
  const category = useSelector((state) => state?.category?.data?.responseData);
  console.log(saleNumber, "😒😒😒F");

  const fileInputRef = useRef(null);

  const propertyNames = [
    {
      name: "MarkCode",
      title: "Mark",
    },
    { name: "PILS", title: "PILS" },
    {
      name: "DamageClaims",
      title: "Damage Claims",
    },
    { name: "SellerChestageAllowance", title: "Seller Chestage Allowance" },
    {
      name: "WithdrawnCharges",
      title: "Withdrawn Charges(Excluding Taxes)",
    },
    // { name: "auctioneerId", title: "Auctioneer ID" },
    {
      name: "SPTFRecovery",
      title: "SPTF",
    },
    {
      name: "FreightCharges",
      title: "Freight Charges",
    },
    { name: "Remarks", title: "Remarks" },
    { name: "ReferenceNo", title: "Reference No." },
  ];

  // const handleFileRemove = (index) => {
  //   setUploadedFiles((prevFiles) => {
  //     const updatedFiles = [...prevFiles];
  //     updatedFiles.splice(index, 1);
  //     return updatedFiles;
  //   });
  //   setInvoiceData([]);
  // };
  // console.log(teaType);
  const dispatch = useDispatch();

  // const { handleChange } = formik;

  useEffect(() => {
    setSubTeaTypeNo(subTeaType);
  }, [subTeaType]);

  useEffect(() => {
    axiosMain
      .post(
        "/preauction/Common/BindMark?auctionCenterId=" + auctionCenterId,
        {}
      )
      .then((res) => {
        if (res.data.statusCode === 200) {
          setMarkDataList(res.data.responseData);
        } else {
          setMarkDataList([]);
        }
      });
  }, []);

  // useEffect(() => {
  //   // setTeaTeatypeList(teaType);
  //   // setMarkDataList(markList);
  //   setGradesList(grades);
  //   if (
  //     warehouseUsersList?.at(0)?.wareHouseUserRegId !== undefined &&
  //     warehouseUsersList?.at(0)?.wareHouseUserRegId !== null
  //   ) {
  //     formik.setFieldValue(
  //       "warehouse",
  //       warehouseUsersList?.at(0)?.wareHouseUserRegId
  //     );
  //   }

  //   formik.setFieldValue("auctioneerId", auctioneer?.at(0)?.userId);
  //   setCategory(category);
  //   // formik.setFieldValue("mark", markList?.at(0)?.markId);
  // }, [teaType, warehouseUsersList, grades, category]);

  function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = currentYear; i > currentYear - 7; i--) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return options;
  }

  const totalPackagesCalculation = (pkgNo) => {
    const firstValue = parseInt(pkgNo?.split("-")[0]);
    const secondValue = parseInt(pkgNo?.split("-")[1]);
    console.log(pkgNo, firstValue - secondValue, "pkgNopkgNo");
    if (firstValue > secondValue) {
      CustomToast.error("package from has to be greater than package to.");
    } else {
      let result = secondValue - firstValue;
      if (result + 1 <= 0) {
        CustomToast.error("package from has to be greater than zero.");
      } else {
        return result + 1;
      }
    }
  };

  // function netKagesCalculation(gross, tare) {
  //   if (gross > tare) {
  //     return gross - tare;
  //   } else {
  //     return gross - tare;
  //     // CustomToast.error(
  //     //   "Tare KGs cannot be greater than or equal to Gross KGs"
  //     // );
  //   }
  // }

  function totalNetKagesCalculation(totalPackage, netKags, sampleQty) {
    const result = totalPackage * netKags;

    return result - sampleQty;
  }

  // console.log(invoiceData, "hi");

  // useEffect(() => {
  //   // console.log(formik.values.warehouse, "formik.values.warehouse");
  //   if (
  //     formik.values.warehouse !== undefined &&
  //     formik.values.warehouse !== null
  //   ) {
  //     axiosMain
  //       .post(`/admin/WareHouseUserReg/dropdown/wareHouseUserRegDetail`, {
  //         wareHouseUserRegId: parseInt(formik.values.warehouse),

  //         // auctionCenterId,
  //       })
  //       .then((response) => {
  //         response.data.responseData?.map((ele) =>
  //           formik.setFieldValue("warehouseAddress", ele.address)
  //         );
  //         response.data.responseData?.map((ele) =>
  //           formik.setFieldValue("warehouseName", ele.wareHouseName)
  //         );
  //       })
  //       .catch((err) => console.log(err));
  //     // let data=warehouseUserList.filter((item)=>item.wareHouseUserRegId===parseInt(formik.values.warehouse));
  //     // formik.setFieldValue("warehouseAddress", data[0]?.address);
  //     // formik.setFieldValue("warehouseName", data[0]?.wareHouseName);
  //   }
  // }, [formik.values.warehouse]);

  // useEffect(() => {
  //   console.log("api cal");
  //   const saleNo = formik.values.saleNo;
  //   const season = formik.values.season;
  //   console.log(saleNo, season, "sas");
  //   // API endpoint URL
  //   const apiUrl = `/preauction/Common/GetSaleProgramDetailBySaleNo`;

  //   // Data to be sent in the POST request

  //   if (saleNo !== null && season !== "") {
  //     // Making the POST request using Axios

  //     axiosMain
  //       .post(apiUrl, {
  //         saleNo: parseInt(saleNo),
  //         season: season?.toString(),
  //         auctionCenterId: auctionCenterId,
  //       })
  //       .then((response) => {
  //         setbaseUrlEng(
  //           response?.data?.responseData[0]?.auctionTypeCode === "BHARAT"
  //             ? "InvoiceDetails"
  //             : "EnglishAuctionInvoiceDetails"
  //         );
  //         // Handle the API response here
  //         const isCatalogClosingDateGreater =
  //           new Date(response?.data?.responseData[0]?.catalogClosingDate) >
  //           new Date();

  //         console.log(
  //           isCatalogClosingDateGreater,
  //           response?.data?.responseData[0]?.catalogClosingDate,
  //           "11111"
  //         );

  //         if (isCatalogClosingDateGreater) {
  //           setCatalogClosingDate(
  //             response?.data?.responseData[0]?.catalogClosingDate
  //           );
  //         } else {
  //           // CustomToast.error("Max Limit Catalog Closing Date");
  //           // setCatalogClosingDate(
  //           //   response?.data?.responseData[0]?.catalogClosingDate
  //           // );\
  //           if (isDisabled) {
  //             console.log(
  //               response?.data?.responseData[0]?.catalogClosingDate,
  //               "11111"
  //             );
  //           } else {
  //             // CustomToast.error(" Catalog Closing Date is expired");
  //           }
  //         }
  //       })
  //       .catch(() => {
  //         // Handle errors here
  //       });
  //   } else {
  //     console.log(saleNo);
  //   }

  //   // Cleanup function, in case you need to cancel the request
  // }, [formik.values.saleNo, formik.values.season]);

  function fixKeyNames(obj) {
    const newObj = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        let fixedKey = key.replace("/", "_"); // Replace '/' with '_'
        fixedKey = fixedKey.replace(".No", "No");
        if (fixedKey === "referenceNo.") {
          fixedKey = "referenceNo";
        }
        newObj[fixedKey] = obj[key];
      }
    }

    return newObj;
  }

  // function excelDateToJSDate(excelDate) {
  //   const MS_PER_DAY = 24 * 60 * 60 * 1000; // Milliseconds per day
  //   const excelStartDate = new Date(1900, 0, 1); // Excel date system starts from January 1, 1900
  //   const excelDays = excelDate - 1; // Excel date is 1-based

  //   const jsTimestamp = excelStartDate.getTime() + excelDays * MS_PER_DAY;
  //   const jsDate = new Date(jsTimestamp);

  //   const day = jsDate.getDate().toString().padStart(2, "0");
  //   const month = (jsDate.getMonth() + 1).toString().padStart(2, "0");
  //   const year = jsDate.getFullYear();

  //   return `${year}-${month}-${day}`;
  // }

  function excelDateToJSDate(excelDate) {
    if (excelDate !== undefined) {
      const MS_PER_DAY = 24 * 60 * 60 * 1000; // Milliseconds per day
      const excelStartDate = new Date(1899, 11, 30); // Excel's incorrect leap year handling
      if (typeof excelDate === "number") {
        const excelDays = excelDate; // Excel date is 1-based

        const jsTimestamp = excelStartDate.getTime() + excelDays * MS_PER_DAY;
        const jsDate = new Date(jsTimestamp);

        const day = jsDate.getDate().toString().padStart(2, "0");
        const month = (jsDate.getMonth() + 1).toString().padStart(2, "0");
        const year = jsDate.getFullYear();

        return isNaN(year) ? "" : `${year}-${month}-${day}`;
      } else if (typeof excelDate === "string" && excelDate.includes("/")) {
        const [day, month, year] = excelDate.split("/").map(Number);

        // Format the date as "YYYY-MM-DD"
        const formattedDate = `${year}-${month
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

        // Create a JavaScript Date object using the formatted date
        // const jsDate = new Date(formattedDate);

        // // Calculate the Excel date by subtracting the start date and dividing by milliseconds per day
        // const excelDays = (jsDate.getTime() - excelStartDate.getTime()) / MS_PER_DAY + 1;
        return formattedDate;
      } else if (typeof excelDate === "string" && excelDate.includes("-")) {
        const [day, month, year] = excelDate.split("-").map(Number);

        // Format the date as "YYYY-MM-DD"
        const formattedDate = `${year}-${month
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

        // Create a JavaScript Date object using the formatted date
        // const jsDate = new Date(formattedDate);

        // // Calculate the Excel date by subtracting the start date and dividing by milliseconds per day
        // const excelDays = (jsDate.getTime() - excelStartDate.getTime()) / MS_PER_DAY + 1;
        return formattedDate;
      } else {
        return ""; // Invalid input format
      }
    } else return "";
  }

  function netKagesCalculation(gross, tare) {
    if (gross > tare) {
      return parseFloat(
        ((isNaN(gross) ? 0 : gross) - (isNaN(tare) ? 0 : tare)).toFixed("2")
      );
    } else {
      return parseFloat(
        ((isNaN(gross) ? 0 : gross) - (isNaN(tare) ? 0 : tare)).toFixed("2")
      );
      // CustomToast.error(
      //   "Tare KGs cannot be greater than or equal to Gross KGs"
      // );
    }
  }

  function totalNetKagesCalculation(totalPackage, netKags, sampleQty) {
    const result = parseFloat((totalPackage * netKags).toFixed("2"));

    return parseFloat((result - sampleQty).toFixed("2"));
  }

  // function getSaleProgramId(saleNos) {
  //   const saleNo = saleNos;
  //   const season = new Date().getFullYear().toString();
  //   // API endpoint URL
  //   const apiUrl = `/preauction/Common/GetSaleProgramDetailBySaleNo?saleNo=${saleNo}&season=${season}`;

  //   // Data to be sent in the POST request

  //   // Making the POST request using Axios

  // }

  // useEffect(() => {
  //   if (uploadData?.length > 0) setTableData(uploadData);
  //   else setTableData([]);
  // }, [uploadData]);
  // useEffect(() => {
  //   if (invoiceData?.length > 0) setTableData(invoiceData);
  //   else setTableData([]);
  // }, [invoiceData]);

  // useEffect(() => {
  //   if (fileData !== []) {
  //     validation(fileData);
  //   }
  // }, [fileData]);

  const handleData = async (uploadedData) => {
    try {
      const updatedFileData = [];
      // if (fileData.length > 0) {
      uploadedData.map(({ fileName, data }) => {
        if (data && data.length > 0) {
          const filteredData = data.filter((obj) => {
            // Check if any key in the object has a defined value
            return Object.values(obj).some((value) => value !== undefined);
          });
          // console.log(filteredData, "filteredData");
          // console.log(uploadedData, "uploadedData");
          const dataList = filteredData.map((ele) => {
            const {
              mark,
              pils,
              damageClaims,
              sellerChestageAllowance,
              withdrawnCharges,
              sptf,
              freightCharges,
              remarks,
              referenceNo,
            } = fixKeyNames(ele);

            let data = {
              // mark: mark,
              // pils,
              // damageClaims,
              // sellerChestageAllowance,
              // withdrawnCharges,
              // sptf,
              // freightCharges,
              // remarks,
              // referenceNo,

              // auctionCenterId: auctionCenterId,

              MarkCode: mark,
              PILS: pils === undefined ? 0.0 : pils,
              DamageClaims: damageClaims === undefined ? 0.0 : damageClaims,
              SellerChestageAllowance:
                sellerChestageAllowance === undefined
                  ? 0.0
                  : sellerChestageAllowance,
              WithdrawnCharges:
                withdrawnCharges === undefined ? 0.0 : withdrawnCharges,
              SPTFRecovery: sptf === undefined ? 0.0 : sptf,
              FreightCharges:
                freightCharges === undefined ? 0.0 : freightCharges,
              // PILS: pils === undefined ? 0 : pils,
              // DamageClaims: damageClaims === undefined ? 0 : damageClaims,
              // SellerChestageAllowance: sellerChestageAllowance === undefined ? 0 : sellerChestageAllowance,
              // WithdrawnCharges: withdrawnCharges === undefined ? 0 : withdrawnCharges,
              // SPTFRecovery: sptf === undefined ? 0 : sptf,
              // FreightCharges: freightCharges === undefined ? 0 : freightCharges,
              Remarks: remarks,
              ReferenceNo: referenceNo?.toString(),
              isActive: true,
              CreatedBy: userId,
              UpdatedBy: userId,
              auctionCenterId: auctionCenterId,
              Status: 1,
            };

            return data;
          });
          // [{
          //   MarkId: values.markId,
          //   ReferenceNo: values.refNo,
          //   PILS: values.pils === "" ? 0 : values.pils,
          //   DamageClaims: values.damageClaims === "" ? 0 : values.damageClaims,
          //   SellerChestageAllowance: values.sellerChestageAllowance === "" ? 0 : values.sellerChestageAllowance,
          //   FreightCharges: values.freightCharges === "" ? 0 : values.freightCharges,
          //   SPTFRecovery: values.sptfRecover === "" ? 0 : values.sptfRecover,
          //   WithdrawnCharges: values.withdrawnCharges === "" ? 0 : values.withdrawnCharges,
          //   Remarks: values.remarks,
          //   Status: values.status,
          //   isActive: true,
          //   CreatedBy: userId,
          //   UpdatedBy: userId,
          //   MarkCode: markDataList?.filter((ele) => ele.markId === values.markId)[0]?.markCode,
          // }];

          // console.log(
          //   dataList.map((ele,indexs) => ele.grossKgs?.toString()?.split(".")[1].length>0 ? indexs+1:false).filter(ele=> ele !== false),
          //   "dataListdataListdataListdataList"
          // );
          // if (
          //   dataList
          //     .map(
          //       (ele) =>
          //         // Number.isInteger(ele.gpNo === "" ? 0 : ele.gpNo) === true ||
          //         (typeof (ele.gpNo === "" ? 0 : ele.gpNo) === "number") ===
          //         true
          //     )
          //     .includes(false)
          // ) {
          //   CustomToast.error("Please enter valid GP NO.");
          // } else {
          updatedFileData.push(dataList);
          // //debugger;;
          // //debugger;;
          //}
          // updatedFileData.push(filteredData);
        } else {
          // Handle the case where the data array is empty
          CustomToast.error(`No data found in file '${fileName}'`);
        }
      });
      // } else {
      //   CustomToast.error(`No file found in fields`);
      // }
      const mergedArray = updatedFileData.reduce((result, currentArray) => {
        return result.concat(currentArray);
      }, []);
      console.log(updatedFileData?.at(0), "updatedFileData");

      allData(mergedArray);
      console.log(mergedArray, "mergedArraymergedArray");
    } catch (error) {
      CustomToast.error(error);
    }
    // validation(uploadedData);
  };

  const allData = (dataList) => {
    const rowsnosaleno = dataList
      ?.map(
        (ele) =>
          ele.saleNo !== null && ele.saleNo !== "" && ele.saleNo !== undefined
      )
      .map((itm, index) => itm === false && index + 1 + 1)
      .filter((itm) => itm !== false);

    // dataList.map((ele) => {
    //   if (ele.saleNo === null || ele.saleNo === '' || ele.saleNo === undefined) {
    //     CustomToast.error("Please Enter sale No. in Row No< " + rowsnosaleno + );
    //     return false;
    //   }
    // });

    if (dataList?.length > 0) {
      // if (rowsnosaleno?.length <= 0) {
      //   const apiUrl = `/preauction/Common/GetSaleProgramDetailBySaleNo`;

      //   axiosMain
      //     .post(apiUrl, {
      //       saleNo: parseInt(dataList?.at(0)?.saleNo),
      //       season: dataList?.at(0)?.season?.toString(),
      //       auctionCenterId: auctionCenterId,
      //     })
      //     .then((response) => {
      //       setbaseUrlEng(
      //         response?.data?.responseData[0]?.auctionTypeCode === "BHARAT"
      //           ? "InvoiceDetails"
      //           : "EnglishAuctionInvoiceDetails"
      //       );
      //       dataList.map((item) => {
      //         item.SaleProgramId = response?.data?.responseData[0]?.SaleProgramId;
      //       });
      //       setCatalogclosingDates(response?.data?.responseData[0]?.catalogClosingDate?.split("T")[0]);
      //       if (uploadData?.length > 0) {
      //         setUploadData([...uploadData, ...dataList]);
      //         setTableData([...dataList]);
      //         //fileInputRef.current.value = "";
      //       } else {
      //         setUploadData([...dataList]);
      //       }

      //       // console.log(data, uploadData, "dataF");
      //     })
      //     .catch((error) => {
      //       // Handle errors here
      //       console.log(error);
      //     });
      // }
      // else {
      if (uploadData?.length > 0) {
        setUploadData([...uploadData, ...dataList]);

        //fileInputRef.current.value = "";
      } else {
        setUploadData([...dataList]);
      }
      const updatedDataList = dataList.map((ele) => {
        // if (ele.PILS === undefined) {
        return {
          ...ele,
          PILS: ele.PILS === undefined ? 0 : ele.PILS,
          FreightCharges:
            ele.FreightCharges === undefined ? 0 : ele.FreightCharges,
          SPTFRecovery: ele.SPTFRecovery === undefined ? 0 : ele.SPTFRecovery,
          DamageClaims: ele.DamageClaims === undefined ? 0 : ele.DamageClaims,
          SellerChestageAllowance:
            ele.SellerChestageAllowance === undefined
              ? 0
              : ele.SellerChestageAllowance,
          WithdrawnCharges:
            ele.WithdrawnCharges === undefined ? 0 : ele.WithdrawnCharges,
        };
        // }
        // else if (ele.FreightCharges === undefined) {
        //   return { ...ele, FreightCharges: 0 };
        // }
        // else if (ele.SPTFRecovery === undefined) {
        //   return { ...ele, SPTFRecovery: 0 };
        // }
        // else if (ele.DamageClaims === undefined) {
        //   return { ...ele, DamageClaims: 0 };
        // }
        // else if (ele.SellerChestageAllowance === undefined) {
        //   return { ...ele, SellerChestageAllowance: 0 };
        // }
        // else if (ele.WithdrawnCharges === undefined) {
        //   return { ...ele, WithdrawnCharges: 0 };
        // }
        // else {
        //   return { ...ele };
        // }
      });
      setTableData(updatedDataList);
      //}
    }
  };
  // const handleFileUpload = async (e) => {
  //   const files = e.target.files;

  //   for (const file of files) {
  //     const fileSize = file.size;
  //     const fileName = file.name;
  //     const fileExtension = fileName.slice(
  //       ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
  //     );
  //     setPropertyNameList(propertyNames);
  //     if (!ALLOWED_EXTENSIONS.includes("." + fileExtension.toLowerCase())) {
  //       CustomToast.error(
  //         `Only Excel files are allowed.`
  //       );
  //     } else if (fileSize > MAX_FILE_SIZE) {
  //       CustomToast.error(
  //         `The file size should not exceed 10MB`
  //       );
  //     } else {
  //       const promises = Array.from(files).map((file) =>
  //         readFileAndCheckHeaders(file)
  //       );

  //       Promise.allSettled(promises).then((results) => {
  //         const fulfilledResults = results.filter(
  //           (result) => result.status === "fulfilled"
  //         );
  //         const dataFromFiles = fulfilledResults.map((result) => result.value);
  //         console.log(dataFromFiles, "dataFromFiles");
  //         handleData(dataFromFiles);
  //       });
  //     }
  //   }
  // };

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    const file = e.target.files[0];
    let boolcheckAllColumn;
    let count = 0;

    // try {
    //   // if (boolcheckAllColumn) {
    //   const filePromises = Array.from(files).map(async (file) => {
    //     const fileSize = file.size;
    //     const fileName = file.name;
    //     const fileExtension = fileName.slice(
    //       ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
    //     );
    //     setPropertyNameList(propertyNames);

    //     if (!ALLOWED_EXTENSIONS.includes("." + fileExtension.toLowerCase())) {
    //       CustomToast.error(`Only Excel files are allowed.`);
    //       return Promise.resolve(null);
    //     } else if (fileSize <= 0) {
    //       CustomToast.error(`File with 0 KB size is not allowed.`);
    //       return Promise.resolve(null);
    //     } else if (fileSize > MAX_FILE_SIZE) {
    //       CustomToast.error(`The file size should not exceed 10MB`);
    //       return Promise.resolve(null);
    //     } else {
    //       boolcheckAllColumn = await checkAllcoulm(file, propertyNameList);
    //       if (boolcheckAllColumn) {
    //         count = count + 1;
    //         return readFileAndCheckHeaders(file);
    //       }
    //     }
    //   });

    //   if (dataFromFiles.length === count) {
    //     const results = await Promise.all(filePromises);
    //     const dataFromFiles = results.filter((result) => result !== null);
    //     console.log(dataFromFiles, "dataFromFiles");
    //     // //debugger;;
    //     handleData(dataFromFiles);
    //   }
    //   // //debugger;;
    // } catch (error) {
    //   console.log("Error occurred during file processing:", error);
    //   // Handle error here
    // }

    for (const file of files) {
      try {
        boolcheckAllColumn = await checkAllcoulm(file, propertyNameList);
        ////debugger;;
        const fileSize = file.size;
        const fileName = file.name;
        const fileExtension = fileName.slice(
          ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        );
        if (!ALLOWED_EXTENSIONS.includes("." + fileExtension.toLowerCase())) {
          // CustomToast.error(
          //   `Only Excel files are allowed.`
          // );

          CustomToast.error(`Only Excel files are allowed.`);
        } else if (fileSize > MAX_FILE_SIZE) {
          CustomToast.error(`The file size should not exceed 10MB`);
        } else if (fileSize === 0) {
          CustomToast.error(`File with 0 KB size is not allowed`);
        } else {
          if (boolcheckAllColumn) {
            count = count + 1;
            const promises = Array.from(files).map((file) =>
              readFileAndCheckHeaders(file)
            );

            Promise.allSettled(promises).then((results) => {
              const fulfilledResults = results.filter(
                (result) => result.status === "fulfilled"
              );
              const dataFromFiles = fulfilledResults.map(
                (result) => result.value
              );
              if (dataFromFiles.length === count) {
                handleData(dataFromFiles);
              }
            });
          }
        }

        // Use vbool as needed
      } catch (error) {
        console.error("Error checking columns:", error);
      }
    }

    // }
  };
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  console.log(
    catalogClosingDate,
    // new Date(catalogClosingDate?.toString()).toLocaleDateString("en-GB"),
    "new Date(catalogClosingDate).toLocaleDateString(en-GB)"
  );

  // const handleExportPDF = () => {
  //   const pdfBlob = (
  //     <PDFViewer width="100%" height="600px">
  //       <Document>
  //         <Page>
  //           <View>
  //             <Text>Name: {formik.values.gpDate}</Text>
  //             <Text>Email: {formik.values.gpNo}</Text>
  //             {/* Add other fields here */}
  //           </View>
  //         </Page>
  //       </Document>
  //     </PDFViewer>
  //   );

  //   const pdfUrl = URL.createObjectURL(
  //     new Blob([pdfBlob], { type: "application/pdf" })
  //   );
  //   window.open(pdfUrl);
  // };

  //Pdf START

  const sourceDivRef = useRef(null);
  // const targetDivRef = useRef(null);

  const showcheckboxlebels = [
    {
      title: "tea Type",
      name: "teaType",
    },
    {
      title: "sub Type",
      name: "subType",
    },
    {
      title: "category",
      name: "category",
    },
    {
      title: "grade",
      name: "grade",
    },
    {
      title: "package Size",
      name: "packageSize",
    },
    {
      title: "package Type",
      name: "packageType",
    },
    {
      title: "package No",
      name: "packageNo",
    },
    {
      title: "total Packages",
      name: "totalPackages",
    },
    {
      title: "gross Kgs",
      name: "grossKgs",
    },
    {
      title: "tare Kgs",
      title: "tareKgs",
    },
    {
      title: "net Kgs",
      name: "netKgs",
    },
    {
      title: "total Net Kgs",
      name: "totalNetKgs",
    },
  ];
  const invoices = [
    {
      name: "SrNo",
      title: "Sr. No.",
    },
    {
      name: "MarkName",
      title: "Mark",
    },
    {
      name: "PILS",
      title: "PILS",
    },
    {
      name: "SellerChestageAllowance",
      title: "Seller Chestage Allowance",
    },
    {
      name: "SPTFRecovery",
      title: "SPTF Recovery",
    },
    {
      title: "Damage Claims",
      name: "DamageClaims",
    },
    {
      name: "WithdrawnCharges",
      title: "Withdrawn Charges (Excluding Taxes)",
    },
    {
      name: "FreightCharges",
      title: "Freight Charges",
    },
    {
      name: "Remarks",
      title: "Remarks",
    },
    {
      name: "ReferenceNo",
      title: "Reference No.",
    },
    {
      name: "ChargesEnteredOn",
      title: "Charges Entered On",
    },
    {
      name: "Status",
      title: "Status",
      getCellValue: (Status) => {
        switch (Status) {
          case 1: {
            return "Not Applied";
          }
          case 2: {
            return "Applied";
          }
          default: {
            return "All";
          }
        }
      },
    },
  ];

  ///PDF END

  return (
    <>
      {/* form end */}
      {/* {modalRight?.includes("6") && ( */}
      <>
        <div>
          <b> Instructions:</b>
          <br />
          {/* <p className="Red" style={{ "font-weight": "bold" }}>
            *Certified that the Teas were weighed at the time of disbatch
            and weights stated are correct. “We here by certify that foods
            mentioned in the invoice are warranted to be of the nature and
            quality which it purports to be, and conform to the P.F.A. Act,
            1954 (Act No. 37 of 1954)”
          </p>
          <br />
          <p className="Red" style={{ "font-weight": "bold" }}>
            Note: Same Invoice no. cannot be used in same “Sale No.”. It
            should be unique for each combination of season, sale number,
            auctioneer, mark, and warehouse. You can reuse the same invoice
            number only if at least one of these details changes.
          </p> */}

          <ul style={{ "font-weight": "bold" }}>
            <li>
              <p className="Red">
                ● User Wise “Reference No.” should be unique with same Mark
                Code.
              </p>
            </li>
            <li>
              <p className="Red">
                ● If any charge (PILS, Damage Claims, Seller Chestage Allowance,
                Freight Charges, or Withdrawn Charges) has already been entered,
                the system will not allow the entry of additional charges.
              </p>
            </li>
            <li>
              <p className="Red">
                ● If the uploaded file contains records with reference numbers
                and marks that already exist in the system, the system will
                handle them based on their current status:
              </p>
            </li>
            <li>
              <p className="Red">
                ● Not Applied Status: The system will update the existing
                records with the new data from the uploaded file.
              </p>
            </li>
            <li>
              <p className="Red">
                ● Applied Status: The system will prevent uploading duplicate
                charges for marks already marked as "Applied."
              </p>
            </li>
            <li>
              <p className="Red">● Any number of excel file can be uploaded.</p>
            </li>
            <li>
              <p className="Red">
                ● Maximum file size should not exceed 10 MB.
              </p>
            </li>
            <li>
              <p className="Red">● Acceptable file types: (*.xls and .xlsx)</p>
            </li>
          </ul>
        </div>

        <div className="row mt-2">
          <div className="col-md-12 BtnGroup">
            <Button
              className="SubmitBtn"
              type="button"
              onClick={() => {
                // fileInputRef.current.value = "";
                setTableData([]);
                setInvoiceData([]);
                setUploadData([]);
                fileInputRef.current.value = "";
              }}
            >
              Clear
            </Button>
            <br />
          </div>
          <div className="col-md-12 mt-2">
            <div className="browse-file FileUpload px-0">
              {/* <FileUpload
   id="fileInput"
   handleData={handleData}
   readFileAndCheckHeaders={readFileAndCheckHeaders}
 /> */}
              <button className="SubmitBtn" onClick={handleButtonClick}>
                Browse
              </button>
              <input
                type="file"
                id="file-upload"
                ref={fileInputRef}
                onChange={handleFileUpload}
                multiple
                accept=".xls,.xlsx"
              />
              <button
                className="SubmitBtn creat-btn"
                type="button"
                onClick={() => submitInvoice()}
              >
                Validate
              </button>
            </div>
          </div>
        </div>
        <div className="TableBox">
          <TableComponent
            columns={propertyNameList}
            rows={tableData}
            setRows={setTableData}
            dragdrop={true}
            module="pre-auction"
            fixedColumnsOn={false}
            resizeingCol={false}
            selectionCol={true}
            sorting={true}
          />
        </div>
      </>

      <Modals
        size="l"
        title="Are you sure you want to submit the Seller Charges ?"
        show={openConformaionModal}
        handleClose={() => {
          setOpenConformaionModal(false);
        }}
      >
        <div className="BtnGroup" style={{ justifyContent: "end" }}>
          <button
            // className="SubmitBtn"
            className="SubmitBtn"
            onClick={() => {
              openLoader();
              axiosMain
                .post(
                  "/preauction/SellerCharges/UploadSellerCharges?flag=upload&validateAction=submit",
                  uploadData.map((ele) => ({
                    ...ele,
                    DamageClaims:
                      ele.DamageClaims === undefined ? 0 : ele.DamageClaims,
                    SellerChestageAllowance:
                      ele.SellerChestageAllowance === undefined
                        ? 0
                        : ele.SellerChestageAllowance,
                    WithdrawnCharges:
                      ele.WithdrawnCharges === undefined
                        ? 0
                        : ele.WithdrawnCharges,
                    SPTFRecovery:
                      ele.SPTFRecovery === undefined ? 0 : ele.SPTFRecovery,
                    FreightCharges:
                      ele.FreightCharges === undefined ? 0 : ele.FreightCharges,
                    PILS: ele.PILS === undefined ? 0 : ele.PILS,
                    MarkId: 0,
                    auctionCenterId
                  }))
                )
                .then((response) => {
                  if (response.data.statusCode === 200) {
                    setOpenConformaionModal(false);
                    CustomToast.success(response.data.message);
                    setExpandedTab("panel1");

                    setInvoiceData([]);
                    setTableData([]);
                    fileInputRef.current.value = "";
                    formikhandlesubmit();
                  }
                  // else if (response.data.statusCode === 422) {
                  //   // CustomToast.warning(response.data.message);
                  //   setOpenConformaionModal(false);
                  //   setOpenModalConformation(true);
                  //   setOpenModalConformationTitle(response.data.message);
                  // } else if (response.data.statusCode === 423) {
                  //   // CustomToast.warning(response.data.message);
                  //   setOpenConformaionModal(false);
                  //   setOpenModalConformationInvalidData(true);
                  //   setOpenModalConformationInvalidDataTitle({
                  //     title: response.data.message,
                  //     responseData: response.data.responseData,
                  //   });
                  //   console.log(response.data, "response.data.message");
                  // }
                  else {
                    setOpenConformaionModal(false);
                    CustomToast.error(response.data.message);
                  }
                  // Handle the response data or success
                  closeLoader();
                })
                .catch((error) => {
                  closeLoader();
                  CustomToast.error("API call failed:", error);
                  // Handle errors here
                });
            }}
          >
            Submit
          </button>

          <button
            className="SubmitBtn"
            // className="SubmitBtn"
            onClick={() => {
              fileInputRef.current.value = "";
              setOpenConformaionModal(false);
              setInvoiceData([]);
              setTableData([]);
              setUploadData([]);
            }}
          >
            Cancel
          </button>
        </div>
      </Modals>

      {/* <ToastContainer /> */}
      {/* {uploadedFiles.length > 0 && (
        <div className="mt-4">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>File Name</th>
                <th>File Type</th>
                <th>File Size</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {uploadedFiles.map((file, index) => (
                <tr key={index}>
                  <td>{file.name}</td>
                  <td>{file.type}</td>
                  <td>{Math.round(file.size / 1024)} KB</td>
                  <td>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleFileRemove(index)}
                    >
                      Remove
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table> 
        </div>
              )}*/}
      <Modals
        show={openModalConformation}
        size="xl"
        // onHide={() => setShow(false)}
        handleClose={() => {
          setOpenModalConformation(false);
          setOpenModalConformationTitle("");
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title={openModalConformationTitle?.split("?")?.at(0) + "?"}
      >
        <div>
          <p>
            {openModalConformationTitle
              ?.split("?")
              ?.at(1)
              ?.split(",")
              ?.join(" , ")}
          </p>
        </div>
        <div className="BtnGroup" style={{ justifyContent: "end" }}>
          <button
            // className="SubmitBtn"
            className="SubmitBtn"
            onClick={() => {
              openLoader();
              axiosMain
                .post(
                  `/preauction/${baseUrlEng}/AddInvoiceDetails?action=update&saleNo=${uploadData?.at(0)?.saleNo
                  }&role=` + roleCode,
                  // uploadData.map((ele) => ({
                  //   ...ele,
                  //   gpNo: ele.gpNo === "" ? null : ele.gpNo?.toString(),
                  // }))
                  uploadData.map((ele) => ({
                    ...ele,
                    gpNo: ele.gpNo === "" ? null : ele.gpNo?.toString(),
                    Category: ele.Category?.toString(),
                    Grade: ele.Grade?.toString(),
                    Mark: ele.Mark?.toString(),
                    SubTeaType: ele.SubTeaType?.toString(),
                    TeaType: ele.TeaType?.toString(),
                    Warehouse: ele.Warehouse?.toString(),
                  }))
                )
                .then((response) => {
                  if (response.data.statusCode === 200) {
                    CustomToast.success(response.data.message);
                    setExpandedTab("panel1");
                    setInvoiceData([]);
                    setTableData([]);
                    setOpenModalConformationTitle("");
                    setOpenModalConformation(false);
                    //handleSubmit();
                  } else if (response.data.statusCode === 422) {
                    // CustomToast.warning(response.data.message);
                    setOpenModalConformation(true);
                    setOpenModalConformationTitle(response.data.message);
                  } else if (response.data.statusCode === 423) {
                    // CustomToast.warning(response.data.message);
                    setOpenModalConformationInvalidData(true);
                    setOpenModalConformationInvalidDataTitle({
                      title: response.data.message,
                      responseData: response.data.responseData,
                    });
                    console.log(response.data, "response.data.message");
                  } else {
                    CustomToast.error(response.data.message);
                  }
                  closeLoader();
                  // Handle the response data or success
                })
                .catch((error) => {
                  closeLoader();
                  CustomToast.error("API call failed:", error);

                  // Handle errors here
                });
            }}
          >
            Yes
          </button>

          <button
            className="SubmitBtn"
            // className="SubmitBtn"
            onClick={() => {
              setOpenModalConformation(false);
            }}
          >
            No
          </button>
        </div>
      </Modals>
      <Modals
        show={openModalConformationInvalidData}
        size="xl"
        // onHide={() => setShow(false)}
        handleClose={() => setOpenModalConformationInvalidData(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title={openModalConformationInvalidDataTitle?.title}
      >
        <ul>
          {openModalConformationInvalidDataTitle?.responseData?.length > 0
            ? openModalConformationInvalidDataTitle?.responseData?.map(
              (ele, index) => <li key={index}>● {ele.InvalidRecord}</li>
            )
            : ""}
        </ul>
      </Modals>

      <Modals
        show={openDelete}
        size="lg"
        // onHide={() => setShow(false)}
        handleClose={() => setOpenDelete(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title="Are you sure you want to submit the invoice ?"
      >
        <div className="BtnGroup">
          <button
            className="SubmitBtn"
            onClick={() => {
              if (invoiceData.length > 0) {
                openLoader();
                // dispatch(addInvoiceDetailsRequest(invoiceData));
                axiosMain
                  .post(
                    `/preauction/${baseUrlEng}/AddInvoiceDetails?saleNo=${invoiceData?.at(0)?.saleNo
                    }`,
                    invoiceData
                  )
                  .then((response) => {
                    // Handle the API response here'

                    // setSelectedSalePrograms({
                    //   ...selectedSalePrograms,
                    //   categoryId: response?.data?.responseData[0].categoryId,
                    // });

                    // const data = {
                    //   factoryId: parseInt(invoiceData?.at(0)?.markId),
                    //   season: invoiceData?.at(0)?.season,
                    //   saleNo: parseInt(invoiceData?.at(0)?.saleNo),
                    //   status: parseInt(invoiceData?.at(0)?.status),
                    //   auctioneerId: userId, //auctioner
                    //   auctionCenterId: auctionCenterId,
                    //   // role:roleCode
                    // };
                    if (response.data.statusCode === 200) {
                      CustomToast.success(response.data.message);
                      setExpandedTab("panel1");
                      setInvoiceData([]);
                      setOpenDelete(false);
                      // axiosMain
                      //   .post(
                      //     `/preauction/${baseUrlEng}/GetInvoiceDetails?role=` +
                      //       roleCode,
                      //     data
                      //   )
                      //   .then((res) => {
                      //     setRows(res.data.responseData);

                      //   });
                      // handleSubmit();
                    } else {
                      CustomToast.error(response.data.message);
                      setOpenDelete(false);
                    }
                    // console.log(response, "invresponse");
                    closeLoader();
                  })
                  .catch(() => {
                    closeLoader();
                    // Handle errors here
                  });
                // console.log(invoiceResponseData, "invoiceResponseData");
              } else {
                CustomToast.error("Please First add invoice");
              }
            }}
          >
            Submit
          </button>

          <button
            className="SubmitBtn"
            onClick={() => {
              setOpenDelete(false);
              setOpenModalConformationTitle("");
            }}
          >
            Cancel
          </button>
        </div>
      </Modals>

      {/* MODAL PRINT */}
      <Modals
        size="l"
        title="Chose For Print"
        show={openPrintModel}
        handleClose={() => {
          setopenPrintModel(false);
        }}
      >
        <PrintInvoice
          fields={invoices}
          showcheckboxlebels={showcheckboxlebels}
          rows={printrow.length > 0 ? printrow : []}
          pageName={"Invoice"}
        />
      </Modals>
    </>
  );
};

export default UploadSellerChargesForm;
